import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';
import CreatePlacementItemDraftService from '../services/CreatePlacementItemDraftService';
import CreatePlacementItemDraftDialog from './CreatePlacementItemDraftDialog';
import { toJS } from 'mobx';

class CreatePlacementItemDraftDialogContainer extends Component {
  static propTypes = {
    placementTestId: PropTypes.string.isRequired,
  };

  componentWillMount() {
    CreatePlacementItemDraftService.init(this.props.placementTestId);
  }

  render() {
    return (
      <CreatePlacementItemDraftDialog
        grammarPlacementTestLevel={toJS(CreatePlacementItemDraftService.grammarPlacementTestLevel)}
        item={toJS(CreatePlacementItemDraftService.item)}
        isOpen={CreatePlacementItemDraftService.isOpen}
        onCancel={CreatePlacementItemDraftService.handleClose}
        onSubmit={CreatePlacementItemDraftService.handleSubmit}
        onChange={CreatePlacementItemDraftService.form.setValue}
        values={CreatePlacementItemDraftService.form.getValues()}
        errors={CreatePlacementItemDraftService.form.errors}
        submitting={CreatePlacementItemDraftService.submit.fetching}
        isDirty={CreatePlacementItemDraftService.form.isDirty}
      />
    );
  }
}

export default observer(CreatePlacementItemDraftDialogContainer);
